var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hot-home-positions-list"},[_c('div',{staticClass:"hot-home-positions-list__wrapper"},[(_vm.positionsLoaded)?_c('hot-positions-list-items',{attrs:{"two-columns":false,"empty-positions-text":_vm.emptyPositionsText,"positions":_vm.positions,"gtm":_vm.gtm}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }